<template>
  <v-navigation-drawer
    v-model="drawer"
    fixed 
    app
    dark
    
  >
    <v-list
      dense
      
    >
      <template v-for="(item, i) in items">
        <v-layout
          v-if="item.heading"
          :key="i"
          row
          align-center
        >

          <v-flex xs6>
            <v-subheader v-if="item.heading">
              {{ item.heading }}
            </v-subheader>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <v-btn small flat>edit</v-btn>
          </v-flex>
        </v-layout>
        <v-divider
          v-else-if="item.divider"
          :key="i"
          dark
          class="my-3"
        ></v-divider>
        <v-list-tile
          v-else
          :key="i"
          @click=""
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title @click="goto('x')" class="grey--text">
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import { mapState } from 'vuex'
  import Vue from 'vue'
  import Vuetify from 'vuetify'

  export default {
    data: () => ({
      drawer: true,
      items: [
        { icon: '', text: 'My contracts' },
        { icon: '', text: 'Billing' },
        { icon: '', text: 'Settings' },
        { divider: true },
      ]
    }),
    props: {
      source: String
    },
    methods: {
      toggleSidebar () {
        this.$store.dispatch('util/toggleSidebarOpen')
      },
      goto(x) {
        this.$vuetify.goTo('#code1', 0, 0)
      }
    },
    computed: {
        ...mapState({
            isDark: state => state.util.isDark,
            isOpenSidebar: state => state.util.isOpenSidebar
        })
    }
  }
</script>